import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Cropper from "./Cropper";
import Sidebar from "../../../partials/aside/Sidebar";
import { Modal, Button } from "react-bootstrap";
import httpService from "../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../helpers/numbers";
import validateFormEditAdvertiseNative from "../../../../validtions/forms/advertise/native/edit-advertise";
import helperSpinner from "../../../../helpers/spinner";

const EditNative = () => {
  const initAdvertiseNative = {
    link: "",
    title: "",
    link_image: "",
  };
  const [advertiseNative, setAdvertiseNative] = useState(initAdvertiseNative);
  const [messageTitleAdvertise, setMessageTitleAdvertise] = useState();
  const [message, setMessage] = useState();
  const history = useHistory();

  const params = useParams();
  const advertiseNativeID = params.id;

  const [imageContentCropped, setImageContentCropped] = useState(null);

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getAdvertiseNative(advertiseNativeID);
  }, []);

  const getAdvertiseNative = async (advertiseNativeID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const advertiseNativeInfo = await sendRequestForGetAdvertiseNative(
      advertiseNativeID
    );
    const linkImage =
      process.env.REACT_APP_DOMAIN_API +
      "/" +
      process.env.REACT_APP_URL_ADVERTISE_FILES +
      "/native/" +
      advertiseNativeInfo.file;

    setAdvertiseNative({
      link: advertiseNativeInfo.link,
      title: advertiseNativeInfo.title,
      link_image: linkImage,
      active: advertiseNativeInfo.active,
      confirm: advertiseNativeInfo.confirm,
      message: advertiseNativeInfo.message,
    });
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestForGetAdvertiseNative = async (advertiseNativeID) => {
    const headersRequest = getHeaderForRequest();
    let advertiseNative;
    try {
      advertiseNative = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/native/" +
          advertiseNativeID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return advertiseNative.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const titleAdvertiseTextAreaKeyPressHandler = () => {
    const titleAdvertise = document.querySelector("#title").value;
    validateTitleAdvertise(titleAdvertise);
    document.querySelector("#preview-advertise-native-title").innerHTML =
      titleAdvertise;
  };

  const validateTitleAdvertise = (titleAdvertise) => {
    if (titleAdvertise.length > 70) {
      setMessageTitleAdvertise(
        <p className="text-danger mt-2">
          عنوان تبلیغ حداکثر می‌تواند ۷۰ کاراکتر باشد.
        </p>
      );
      return;
    }

    if (titleAdvertise.length > 55) {
      setMessageTitleAdvertise(
        <div className="alert alert-warning mt-2">
          <span className="text-white pl-2">
            <i className="fa fa-exclamation-triangle"></i>
          </span>
          <span className="text-white">
            تعداد کاراکترهای عنوان تبلیغ بیشتر از ۵۵ است و ممکن است برخی اوقات
            به درستی نمایش داده نشود.
          </span>
        </div>
      );
      return;
    }

    setMessageTitleAdvertise();
  };

  const setImageCroppedToPreviewImageArea = (imageContent) => {
    setImageContentCropped(imageContent);
    const previewImageNativeAdvertisingTag = document.querySelector(
      "#preview-image-native-advertising"
    );
    previewImageNativeAdvertisingTag.style.background = "";
    previewImageNativeAdvertisingTag.style.background =
      "url(" + imageContent + ")";
    previewImageNativeAdvertisingTag.style.backgroundSize = "cover";
    previewImageNativeAdvertisingTag.style.backgroundPosition = "100% 100%";
    previewImageNativeAdvertisingTag.style.backgroundRepeat = "no-repeat";
  };

  const sendForm = async (e) => {
    e.preventDefault();
    let dataForm = getDataForm();
    if (dataForm == false) {
      return;
    }

    if (await sendRequestForEditAdvertiseNative(advertiseNativeID, dataForm)) {
      history.push("/advertise/native/all");
    }
  };

  const sendRequestForEditAdvertiseNative = async (
    advertiseNativeID,
    dataForm
  ) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    const headersRequest = getHeaderForRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/native/" +
          advertiseNativeID,
        dataForm,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getDataForm = () => {
    const address = document.querySelector("#address").value;
    const title = document.querySelector("#title").value;
    const active = document.querySelector("#active").checked ? "1" : "0";

    let dataInputs = {
      address: address,
      title: title,
      active: active,
    };

    if (imageContentCropped != null) {
      dataInputs.image_content = imageContentCropped;
    }

    if (validateFormEditAdvertiseNative(dataInputs) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormEditAdvertiseNative(dataInputs),
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return dataInputs;
  };

  let messageFailedTag = "";
  if (advertiseNative.confirm == 2) {
    if (advertiseNative.message) {
      messageFailedTag = (
        <div className="alert alert-danger">{advertiseNative.message}</div>
      );
    }
  }

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  ویرایش کردن تبلیغ همسان
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageFailedTag}
              {messageTag}
              <form onSubmit={sendForm}>
                <div className="form-group px-2">
                  <label>آدرس صفحه‌ی فرود تبلیغ شما </label>
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      class="form-control"
                      defaultValue={advertiseNative.link}
                      id="address"
                    />
                    <div class="input-group-append">
                      <a
                        target="_blank"
                        class="btn btn-primary"
                        type="button"
                        href={advertiseNative.link}
                      >
                        <i className="fa fa-eye"></i>
                      </a>
                    </div>
                  </div>
                </div>

                <div className="container-fluid">
                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
                      <div>
                        <div className="form-group">
                          <label>عنوان تبلیغ شما</label>
                          <textarea
                            className="form-control"
                            id="title"
                            defaultValue={advertiseNative.title}
                            onKeyUp={() =>
                              titleAdvertiseTextAreaKeyPressHandler()
                            }
                          ></textarea>
                          {messageTitleAdvertise}
                        </div>

                        <div className="form-group">
                          <div>
                            <label>بارگذاری تصویر </label>
                          </div>
                          <div>
                            <Cropper
                              setImageCroppedToPreviewImageArea={
                                setImageCroppedToPreviewImageArea
                              }
                            />
                          </div>

                          <div className="alert alert-info mt-2">
                            <p>
                              برای اینکه عکس با کیفیتی داشته باشید، عکس خود را
                              با طول ۶۰۰ و عرض ۴۰۰ پیکسل یا در نسبت ۳ به ۲ آپلود
                              کنید!
                            </p>
                            <p>
                              تبلیغات همسان را در فرمت‌های png و jpeg بارگذاری
                              کنید.
                            </p>
                          </div>
                          <div className="pb-2">
                            <div>
                              <label>فعال</label>
                            </div>
                            <div>
                              <span>
                                <label className="adl-switch">
                                  <input
                                    type="checkbox"
                                    defaultChecked={advertiseNative.active}
                                    id="active"
                                  />
                                  <span className="adl-slider round"></span>
                                </label>
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
                      <div>
                        <div>
                          <label>پیش نمایش</label>
                        </div>
                        <div
                          id="preview-native-advertising-container"
                          className="border border-1"
                        >
                          <div>
                            <div
                              id="preview-image-native-advertising"
                              style={{
                                backgroundImage:
                                  "url(" + advertiseNative.link_image + ")",
                                backgroundSize: "cover",
                                backgroundPosition: "100% 100%",
                                backgroundRepeat: "no-repeat",
                              }}
                              className="w-100 "
                            />
                          </div>
                          <hr className="m-0" />
                          <div>
                            <p
                              id="preview-advertise-native-title"
                              className="p-3 m-0"
                            >
                              {advertiseNative.title}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="px-2 pt-2  ">
                  <button type="submit" className="btn btn-primary">
                    اضافه کردن
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default EditNative;
